import { Link } from 'react-router-dom';
import { ArrowLeft, SearchX } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';

export const DetailSkeleton = () => (
  <div className="px-4 sm:px-5 lg:px-8 py-6 sm:py-8 lg:py-10 max-w-5xl mx-auto" data-testid="detail-loading">
    <Skeleton className="h-5 w-32 mb-6" />
    <Skeleton className="h-44 rounded-3xl" />
    <div className="grid sm:grid-cols-3 gap-4 mt-6">
      <Skeleton className="h-28 rounded-2xl" /><Skeleton className="h-28 rounded-2xl" /><Skeleton className="h-28 rounded-2xl" />
    </div>
    <Skeleton className="h-40 rounded-2xl mt-6" />
  </div>
);

export const DetailNotFound = ({ backTo = '/app', label = 'Back' }) => (
  <div className="px-4 sm:px-5 lg:px-8 py-20 max-w-xl mx-auto text-center" data-testid="detail-not-found">
    <div className="h-14 w-14 rounded-2xl bg-secondary grid place-items-center mx-auto mb-5 text-muted-foreground"><SearchX className="h-6 w-6" /></div>
    <h1 className="font-display text-3xl">Not found.</h1>
    <p className="text-muted-foreground mt-2">This item doesn’t exist or was removed.</p>
    <Button asChild variant="outline" className="mt-6 rounded-full"><Link to={backTo}><ArrowLeft className="h-4 w-4 mr-2" /> {label}</Link></Button>
  </div>
);
